import { Dispatch, SetStateAction, useEffect } from 'react';

export const useSlaveGridMultiselectModeChecker = (
  selectedRows: any[],
  expandedRow: any,
  setExpandedRow: Dispatch<SetStateAction<any>>
) => {
  useEffect(() => {
    if (selectedRows.length > 0 && expandedRow !== null) {
      setExpandedRow(null);
    }
  }, [selectedRows, expandedRow]);
};
